// extracted by mini-css-extract-plugin
export default {"title":"rating_title__90ytT","trackTabs":"rating_trackTabs__4lnEG","trackTab":"rating_trackTab__OQSCf","trackTabActive":"rating_trackTabActive__nTo9L"};